import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "api/baseurl";
import MDInput from "components/MDInput";
import Pagination from "@mui/material/Pagination";
import { InputAdornment } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams } from "react-router-dom";

import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  Card,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";
import Box from "@mui/material/Box";
import { keyframes } from "@mui/system";

function ViewDeviceData() {
      const { id } = useParams();
    // const cleanDeviceName = decodeURIComponent(devicename).trim();

  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const userid = loginData?.userid;
const [currentPage, setCurrentPage] = useState(0);
const [totalPages, setTotalPages] = useState(0);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(true);

  const [mappingDetails, setMappingDetails] = useState({
    doctorid: "",
    patientid: "",
    ccid: "",
    date: "",
  });

  const [mappingList, setMappingList] = useState([]);
  const navigate = useNavigate();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteModal, setDeleteModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");

  // 🔹 Add Modal
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);



  // 🔹 Delete Modal
  const handleOpenDeleteModal = (id) => {
    setSelectedId(id);
    setDeleteModal(true);
  };
  const handleCloseDeleteModal = () => setDeleteModal(false);

  // 🔹 Input change handler
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setMappingDetails((prevDetails) => ({ ...prevDetails, [name]: value }));
  };

  

  const fetchMapping = async (pageNumber = 1) => {
    try {
      const secretKey = await fetchSecretKey();
      const token = JSON.parse(localStorage.getItem("loginData"))?.token;
      if (!token) throw new Error("Authentication token not found.");

      const response = await axios.get(`/api/devicedata/devicename/by-id/${id}`, {
        params: { page: Math.max(0, pageNumber - 1) },    
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  

      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        setMappingList(decryptedData.content || []);
         setCurrentPage(decryptedData.number + 1);
          setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error fetching mappings:", error);
    //   toast.error("Failed to fetch mappings.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMapping();
  }, []);
 const handlePageChange = (_, pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    if (searchTerm) {
      setCurrentPage(); 
    }
  }, [searchTerm]);
  
  useEffect(() => {
    if (searchTerm) {
      searchData(currentPage); 
    } else {
      fetchMapping(currentPage);
    }
  }, [searchTerm, currentPage]);
  
  
  const searchData = async (pageNumber = 1) => {
    setLoading(true);
     
      
       console.log("Search term before API call:", searchTerm);
       try {
         setLoading(true);
         const secretKey = await fetchSecretKey();
         const token = JSON.parse(localStorage.getItem("loginData")).token;
     
         const requestBody = encryptBody({ ccid:userid,searchTerm: searchTerm }, secretKey);
   
      const response = await axios.post(`/api/devicedata/searchByCcid/${userid}`, requestBody, {
        params: { page: Math.max(0, pageNumber - 1) },  
            headers: {
          "Content-Type": "text/plain",
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.status === 200) {
        const decryptedData = decryptBody(response.data, secretKey);
        console.log("Decrypted Search Response:", decryptedData); 
        setMappingList(decryptedData.content || []);
        setCurrentPage(decryptedData.number + 1);
        setTotalPages(decryptedData.totalPages);
      }
    } catch (error) {
      console.error("Error searching :", error);
    } finally {
      setLoading(false);
    }
  };
  // Loader Animation
  const spinAnimation = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  `;
  const dotPositions = [
    { top: "5%", left: "50%" },
    { top: "20%", left: "80%" },
    { top: "50%", left: "95%" },
    { top: "80%", left: "80%" },
    { top: "95%", left: "50%" },
    { top: "80%", left: "20%" },
    { top: "50%", left: "5%" },
    { top: "20%", left: "20%" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {/* Loader */}
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
          }}
        >
          <Box
            sx={{
              position: "relative",
              width: 80,
              height: 80,
              animation: `${spinAnimation} 1.5s linear infinite`,
            }}
          >
            {dotPositions.map((pos, index) => (
              <Box
                key={index}
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  backgroundColor:"#2e7faeff",
                  position: "absolute",
                  ...pos,
                }}
              />
            ))}
          </Box>
        </Box>
      )}
 <MDBox mt={1} p={1} display="flex"  alignItems="center">
      <MDTypography variant="h5" sx={{ flex: 1 }}>
       Device Data
  </MDTypography>
 
    <MDBox sx={{ flex: 6, display: "flex", justifyContent: "center" }}>
          <MDInput
                     placeholder="Search Patient Name Device Name "
                     variant="outlined"
                 fullWidth
                 value={searchTerm}
                 onChange={(e) => setSearchTerm(e.target.value)}
                 sx={{
                   maxWidth: "400px",
                   backgroundColor: "#fff",
                   borderRadius: "8px",
                 }}
                 InputProps={{
                   startAdornment: (
                     <InputAdornment position="start">
                       <IconButton size="small">
                         <SearchIcon />
                       </IconButton>
                     </InputAdornment>
                   ),
                 }}
               />
                 </MDBox>

      </MDBox>
     

      {/* Table */}
      <MDBox sx={{ overflowX: "auto", width: "100%" }}>
         <TableContainer component={Paper} sx={{ mt: 3, border: "1px solid #ddd", borderRadius: "8px", boxShadow: "2px 4px 10px rgba(0,0,0,0.1)" }}>
       
    <Table sx={{ tableLayout: "fixed", width: "100%", borderCollapse: "collapse" }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: "#2e7faeff" }}>
                {[ "Patient Name", "Device Name",  "Data Type", "Datavalue","Recorded At"].map((header, index) => (
                  <TableCell
                    key={index}
                   sx={{
                fontWeight: "bold",
                border: "1px solid #ddd",
                textAlign: "center",
                padding: "7px",
  minWidth: index === 0 ? "200px" : "100px",
width: index === 0 ? "315px" : "230px",

                whiteSpace: "nowrap",  
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {header}
            </TableCell>
          ))}

       
  </TableRow>

            <TableBody>
              {mappingList.length > 0 ? (
                mappingList.map((mapping, index) => (
                  <TableRow key={index}>
                  
                <TableCell
  sx={{
    border: "1px solid #ddd",
    textAlign: "center",
    padding: "12px",
  
  }}
>
  {mapping?.patientname}
</TableCell>


                    <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping?.devicename} 
                    </TableCell>
                   
                    <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.datatype}
                    </TableCell>
                  <TableCell sx={{ border: "1px solid #ddd", padding: "12px" }}>
  <ul style={{ margin: 0, paddingLeft: "16px" }}>
    {mapping.bp_systolic != null && (
      <li>
        <MDTypography variant="body2">
          <strong>BP Systolic:</strong>{" "}
          <span style={{ color: "#2e7fae", fontWeight: 700 }}>
            {mapping.bp_systolic}
          </span>
        </MDTypography>
      </li>
    )}

    {mapping.bp_diastolic != null && (
      <li>
        <MDTypography variant="body2">
          <strong>BP Diastolic:</strong>{" "}
          <span style={{ color: "#2e7fae", fontWeight: 700 }}>
            {mapping.bp_diastolic}
          </span>
        </MDTypography>
      </li>
    )}

    {mapping.bp_mean != null && (
      <li>
        <MDTypography variant="body2">
          <strong>BP Mean:</strong>{" "}
          <span style={{ color: "#2e7fae", fontWeight: 700 }}>
            {mapping.bp_mean}
          </span>
        </MDTypography>
      </li>
    )}

    {mapping.random_sugar != null && (
      <li>
        <MDTypography variant="body2">
          <strong>Random Sugar:</strong>{" "}
          <span style={{ color: "#2e7fae", fontWeight: 700 }}>
            {mapping.random_sugar}
          </span>
        </MDTypography>
      </li>
    )}
  </ul>
</TableCell>



                     
                      <TableCell sx={{ border: "1px solid #ddd", textAlign: "center", padding: "12px" }}>
                      {mapping.recorded_at}
                    </TableCell>
                       
                    
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell
                    colSpan={7}
                    align="center"
                    sx={{ border: "1px solid #ddd", padding: "12px", fontStyle: "italic", color: "gray" }}
                  >
                    No Data Available.
                  </TableCell>
                </TableRow>
              )}
              
            </TableBody>
                        </TableHead>

            <Box mt={2} display="flex" justifyContent="center">
                      <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        color="success"
                         sx={{
                "& .MuiPaginationItem-root": {
                  borderRadius: "4px",
                  color: "#2e7faeff",         
                  borderColor: "#2e7faeff",    
                },
                "& .MuiPaginationItem-root.Mui-selected": {
                  backgroundColor: "#2e7faeff", 
                  color: "#fff",                
                },
                "& .MuiPaginationItem-root:hover": {
                  backgroundColor: "#2e7faeff33", 
                },
              }}
                      />
                    </Box>
          </Table>
        </TableContainer>
      </MDBox>

     
    </DashboardLayout>
  );
}

export default ViewDeviceData;
